import { enableFade } from 'core/handlers/FadeHandler'
import { signal } from 'services/SignalsService'

export default class BetEntity extends PIXI.Container {
  constructor() {
    super()
    this.interactive = false
    this.interactiveChildren = false
    const fade = enableFade(this)

    signal.on('RADIO:ui', (value) => {
      fade(value == 'bet')
      const isBet = value == 'bet' ? 'bet' : ''
      if (value === 'bet') {
        this.interactive = true
        this.interactiveChildren = true
        signal.dispatch(`RADIO:menu:${isBet}`)
      }
      else {
        this.interactive = false
        this.interactiveChildren = false
      }
    })
  }
}
